<template>
  <div class="referral-program-members">
    <HeadSection
      :breadcrumbs="breadcrumbs"
      :permissionOfSection="permissionOfSection"
    />
    <MainContainer :loading="userLoading" :permissionOfSection="permissionOfSection" :isBlockStyle="true">
      <div class="tabs-container">
        <a-tabs
          v-model="activeRoleTab"
          type="card"
          tab-position="top"
        >
          <a-tab-pane
            v-for="role in availableRoles"
            :key="role.system_name"
          >
            <template #tab>
              <DefaultLabelTab
                :name="role.name"
              />
            </template>
            <component
              :is="role.component"
              :role="role"
              :program="program"
              :createPermission="createPermission"
            />
          </a-tab-pane>
        </a-tabs>
      </div>
    </MainContainer>
  </div>
</template>

<script>
import HeadSection from '@/components/main/headSection'
import MainContainer from '@/components/main/mainContainer'
import DefaultLabelTab from '@/views/apps/referral-program/components/DefaultLabelTab.vue'
import { getProgramParams } from '@/views/apps/referral-program/referral-programs/composables/useGetProgramParams.js'
import { capitalizeFirstLetter } from '@/composables/useCapitalizeFirstLetter.js'
import { getReferralRoles } from '@/views/apps/referral-program/composables/useGetReferralRoles.js'
import AffiliatesTable from '@/views/apps/referral-program/referral-programs/members/components/AffiliatesTable.vue'
import ReferralsTable from '@/views/apps/referral-program/referral-programs/members/components/ReferralsTable.vue'

export default {
  props: {
    createPermission: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeadSection,
    MainContainer,
    DefaultLabelTab,
    AffiliatesTable,
    ReferralsTable,
  },
  data: () => ({
    permissionOfSection: 'referral_program',
    program: null,
    programId: null,

    activeRoleTab: 'affiliate',
    availableRoles: [],
    getAvailableRolesLoading: false,

    loading: false,
  }),
  computed: {
    userLoading() {
      return this.$store.state?.user?.loading || false
    },
    innerProgramName() {
      return this.program?.name || ''
    },
    breadcrumbs() {
      return [
        { name: 'Referral programs', link: '/referral/programs' },
        { name: this.innerProgramName, link: `/referral/programs/${this.program?.id}` },
        { name: 'Members', link: null },
      ]
    },
  },
  methods: {
    async getAvailableRoles() {
      try {
        this.getAvailableRolesLoading = true
        const roles = await getReferralRoles() || []
        this.availableRoles = roles.map(role => {
          return {
            id: role.id,
            name: `${capitalizeFirstLetter(role.name)}s`,
            system_name: role.system_name,
            component: `${capitalizeFirstLetter(role.name)}sTable`,
          }
        })
      } finally {
        this.getAvailableRolesLoading = false
      }
    },
    async getProgramParams() {
      const data = await getProgramParams(this.programId)
      if (data) {
        this.program = data
        return
      }
      this.$router.push('/referral/programs')
    },
  },
  async mounted() {
    if (Object.keys(this.$route.query)?.length) {
      const params = new URLSearchParams(this.$route.query)
      const firstKey = params.keys().next().value
      const prefix = firstKey.split(/[-_]/)[0]
      if (prefix === 'ref') {
        this.activeRoleTab = 'referral'
      }
    }
    this.programId = this.$route.params.id
    const requests = [this.getProgramParams(), this.getAvailableRoles()]

    await Promise.all(requests)
  },
}
</script>

<style lang="scss">
.referral-program-members {
  .ant-table-row {
    cursor: pointer;
  }
  .tabs-container {
    overflow: hidden;
    height: 100%;
  }
  .tabs-container > .ant-tabs {
    height: 100%;
  }
  .tabs-container > .ant-tabs-card > .ant-tabs-content {
    height: 100%;
    margin-top: -16px;
  }

  .tabs-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    background: #fff !important;
    padding: 16px;
  }
  .tabs-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane-active {
    height: 100%;
  }
  .tabs-container > .ant-tabs-card > .ant-tabs-bar {
    border-color: #fff !important;
  }

  .tabs-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
    margin-right: 0 !important;
  }

  .tabs-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
    border-color: #fff !important;
    background: #fff !important;
  }
}
</style>
